/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rental_Night_SingularInputs */

const en_rental_night_singular = /** @type {(inputs: Rental_Night_SingularInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`night`)
};

const es_rental_night_singular = /** @type {(inputs: Rental_Night_SingularInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`noche`)
};

const fr_rental_night_singular = /** @type {(inputs: Rental_Night_SingularInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`nuit`)
};

const de_rental_night_singular = /** @type {(inputs: Rental_Night_SingularInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nacht`)
};

const id_rental_night_singular = /** @type {(inputs: Rental_Night_SingularInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`malam`)
};

/** @type {(inputs: Rental_Night_SingularInputs) => LocalizedString} */
const ja_rental_night_singular = en_rental_night_singular;

/** @type {(inputs: Rental_Night_SingularInputs) => LocalizedString} */
const zh_rental_night_singular = en_rental_night_singular;

/** @type {(inputs: Rental_Night_SingularInputs) => LocalizedString} */
const ar_rental_night_singular = en_rental_night_singular;

/** @type {(inputs: Rental_Night_SingularInputs) => LocalizedString} */
const it_rental_night_singular = en_rental_night_singular;

/** @type {(inputs: Rental_Night_SingularInputs) => LocalizedString} */
const ru_rental_night_singular = en_rental_night_singular;

/** @type {(inputs: Rental_Night_SingularInputs) => LocalizedString} */
const pt_rental_night_singular = en_rental_night_singular;

/** @type {(inputs: Rental_Night_SingularInputs) => LocalizedString} */
const ko_rental_night_singular = en_rental_night_singular;

/**
* | output |
* | --- |
* | "night" |
*
* @param {Rental_Night_SingularInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const rental_night_singular = /** @type {((inputs?: Rental_Night_SingularInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rental_Night_SingularInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_rental_night_singular(inputs)
	if (locale === "es") return es_rental_night_singular(inputs)
	if (locale === "fr") return fr_rental_night_singular(inputs)
	if (locale === "de") return de_rental_night_singular(inputs)
	if (locale === "ja") return ja_rental_night_singular(inputs)
	if (locale === "zh") return zh_rental_night_singular(inputs)
	if (locale === "ar") return ar_rental_night_singular(inputs)
	if (locale === "id") return id_rental_night_singular(inputs)
	if (locale === "it") return it_rental_night_singular(inputs)
	if (locale === "ru") return ru_rental_night_singular(inputs)
	if (locale === "pt") return pt_rental_night_singular(inputs)
	return ko_rental_night_singular(inputs)
});